import { render } from "./EmployeeDetails.vue?vue&type=template&id=92ebf700&scoped=true"
import script from "./EmployeeDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeDetails.vue?vue&type=script&lang=js"

import "./EmployeeDetails.vue?vue&type=style&index=0&id=92ebf700&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92ebf700"]])

export default __exports__